import React, { useState } from "react";
import countryData from "./countryCodes.json";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import useClickOutside from "hooks/useClickOutside";

const CountryDropdown = ({ onSelectCountry }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const defaultCountry = countryData.find(country => country.code === "US");
	const [selectedCountry, setSelectedCountry] = useState(defaultCountry || countryData[0]);

	const dropdownRef = useClickOutside(() => setIsOpen(false));

	const handleSelectCountry = (country) => {
		setSelectedCountry(country);
		onSelectCountry(country);
		setIsOpen(false);
	};

	const filteredCountries = countryData.filter(country =>
		country.name.toLowerCase().includes(searchTerm.toLowerCase())
	);

	return (
		<div ref={dropdownRef}>
			<button
				type="button"
				className="w-full text-left flex items-center"
				onClick={() => setIsOpen(!isOpen)}
			>
				<span className="size-5 scale-125">{selectedCountry.emoji}</span>
				<Arrow className="rotate-90 float-right fill-current" />
			</button>
			{isOpen && (
				<div className="absolute w-full bg-white border border-gray-300 mt-1 max-h-60 overflow-y-auto">
					<input
						type="text"
						placeholder="Search..."
						className="w-full p-2"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
					/>
					{filteredCountries.map(country => (
						<div
							key={country.code}
							className="p-2 cursor-pointer text-black hover:bg-gray-100 flex items-center"
							onClick={() => handleSelectCountry(country)}
						>
							<span className="mr-2">{country.emoji}</span>
							<span>{country.name}</span>
							<span className="ml-auto">{country.dial_code}</span>
						</div>
					))}
				</div>
			)}
		</div>
	);
};


export default CountryDropdown;
